import { connect } from 'react-redux'
import { createWidget } from 'pages/widgets/form-actions/create/actions'
import Form from 'pages/widgets/form'
import { getInitialFbCompetitionValues } from './initialValues'

const mapDispatch = {
  onSubmit: createWidget
}

const date = new Date().valueOf()

export default connect(
  () => ({ initialValues: getInitialFbCompetitionValues(date) }),
  mapDispatch
)(Form)



// WEBPACK FOOTER //
// ./src/pages/widgets/fb-competition/create/container/index.js